import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import { AddressBlock } from 'components/sections/common'
import { apiOrganizations, apiDownloadFile } from 'helpers/decorators/api'
import { FloatingBar, FormButton } from 'components/misc'
import { Form } from 'components/layout'
import { form, meta } from 'helpers/decorators'
import { OfficeGeneralDetails } from 'components/sections/national-offices'
import DetailLoader from 'components/loaders/DetailLoader/DetailLoader'

const enhance = compose(
  meta({
    title: 'My regional office',
    intlKey: 'route.my_region_office',
  }),
  apiOrganizations({
    myDetail: true,
  }),
  apiDownloadFile(),
  form({
    form: 'regional-office-detail',
    initialProps: 'organizations.detail',
  }),
  connect(({ api }) => ({
    blobs: api.blobs,
  }))
)

class MyRegionOffice extends Component {
  static propTypes = {
    values: PropTypes.object,
    files: PropTypes.object,
    blobs: PropTypes.object,
    organizations: PropTypes.object,
    handleSubmit: PropTypes.func.isRequired,
    change: PropTypes.func.isRequired,
    updateMyOrganization: PropTypes.func.isRequired,
    onDownloadFile: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  }

  render() {
    const {
      handleSubmit,
      updateMyOrganization,
      change,
      values,
      blobs,
      organizations,
      files,
    } = this.props

    const loading = blobs.loading || organizations.loading

    if (loading) {
      return <DetailLoader withLogo />
    }

    return (
      <Form onSubmit={handleSubmit(updateMyOrganization)} loading={loading}>
        <OfficeGeneralDetails
          change={change}
          data={values}
          onDownloadFile={this.props.onDownloadFile}
          files={files}
          displaySettings={false}
          isRegion
        />
        <div className="row">
          <div className="col-xs-6">
            <AddressBlock
              intlKey="moduleTitle.billing_address"
              formPrefix="invoiceAddress"
              change={change}
              withCountry
              isOrganizationAddress
            />
          </div>
          <div className="col-xs-6">
            <AddressBlock
              intlKey="moduleTitle.shipping_address"
              formPrefix="address"
              copyFrom="invoiceAddress"
              data={values}
              change={change}
              withAction
              withCountry
              isOrganizationAddress
            />
          </div>
        </div>
        <FloatingBar>
          <FormButton {...this.props} intlKey="button.save">
            Save
          </FormButton>
        </FloatingBar>
      </Form>
    )
  }
}

export default enhance(MyRegionOffice)
